import _objectSpread from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/home/runner/work/ChronoLog/ChronoLog/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import createWithBsPrefix from './createWithBsPrefix';
import divWithClassName from './divWithClassName';
import CardImg from './CardImg';
import CardHeader from './CardHeader';
import { jsx as _jsx } from "react/jsx-runtime";
var DivStyledAsH5 = divWithClassName('h5');
var DivStyledAsH6 = divWithClassName('h6');
var CardBody = createWithBsPrefix('card-body');
var CardTitle = createWithBsPrefix('card-title', {
  Component: DivStyledAsH5
});
var CardSubtitle = createWithBsPrefix('card-subtitle', {
  Component: DivStyledAsH6
});
var CardLink = createWithBsPrefix('card-link', {
  Component: 'a'
});
var CardText = createWithBsPrefix('card-text', {
  Component: 'p'
});
var CardFooter = createWithBsPrefix('card-footer');
var CardImgOverlay = createWithBsPrefix('card-img-overlay');
var defaultProps = {
  body: false
};
var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    bg = _ref.bg,
    text = _ref.text,
    border = _ref.border,
    body = _ref.body,
    children = _ref.children,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "bg", "text", "border", "body", "children", "as"]);
  var prefix = useBootstrapPrefix(bsPrefix, 'card');
  return /*#__PURE__*/_jsx(Component, _objectSpread({
    ref: ref
  }, props, {
    className: classNames(className, prefix, bg && "bg-".concat(bg), text && "text-".concat(text), border && "border-".concat(border)),
    children: body ? /*#__PURE__*/_jsx(CardBody, {
      children: children
    }) : children
  }));
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
export default Object.assign(Card, {
  Img: CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
});